// import { Navigate } from "react-router-dom";
// import { useAuth } from "./context/AuthProvider";
// import useStore from "./store/store";
// import { hasAllPermissions } from "./helpers/accessHelper";

// const PermissionRoute = ({ permissions = [], children }) => {
//   const { isAuthenticated } = useAuth();
//   const user = useStore((state) => state.user);

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   if (!hasAllPermissions(user, permissions)) {
//     return <Navigate to="/not-authorized" replace />;
//   }

//   return children;
// };

// export default PermissionRoute;

// import { Navigate } from "react-router-dom";
// import { useAuth } from "./context/AuthProvider";
// import useStore from "./store/store";
// import { hasAllPermissions } from "./helpers/accessHelper";

// const PermissionRoute = ({ permissions = [], children }) => {
//   const { isAuthenticated, user: authUser, isHydrated } = useAuth();
//   const storeUser = useStore((state) => state.user);

//   const user = authUser || storeUser;

//   if (!isHydrated) {
//     return (
//       <div className="w-full h-full flex items-center justify-center p-8">
//         Loading...
//       </div>
//     );
//   }

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   if (!user) {
//     return <Navigate to="/login" replace />;
//   }

//   if (!hasAllPermissions(user, permissions)) {
//     return <Navigate to="/not-authorized" replace />;
//   }

//   return children;
// };

// export default PermissionRoute;

import { Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthProvider";
import useStore from "./store/store";
import { hasAllPermissions } from "./helpers/accessHelper";

const PermissionRoute = ({ permissions = [], children }) => {
  const { isAuthenticated, user: authUser, isHydrated } = useAuth();
  const storeUser = useStore((state) => state.user);

  const user = authUser || storeUser;

  if (!isHydrated) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!hasAllPermissions(user, permissions)) {
    return <Navigate to="/not-authorized" replace />;
  }

  return children;
};

export default PermissionRoute;